// Needs to have the same name as the Feature enum in CLB!

export enum FeatureSwitch {
  FEATURE_FOR_UNIT_TESTS = 'FEATURE_FOR_UNIT_TESTS',
  PPA_11933_USE_NEW_SUPPLY_DEMAND = 'PPA_11933_USE_NEW_SUPPLY_DEMAND',
  PPA_12148_HEYIMMO = 'PPA_12148_HEYIMMO',
  PPA_12214_SEGMENTATION_WITHOUT_CTA = 'PPA_12214_SEGMENTATION_WITHOUT_CTA',
  PPA_12241_AI_DATA_EXTRACTION_BANNER = 'PPA_12241_AI_DATA_EXTRACTION_BANNER',
}

export const FeatureSwitchesDefaultValues: FeatureSwitchMap = {
  [FeatureSwitch.FEATURE_FOR_UNIT_TESTS]: true,
  [FeatureSwitch.PPA_11933_USE_NEW_SUPPLY_DEMAND]: false,
  [FeatureSwitch.PPA_12148_HEYIMMO]: false,
  [FeatureSwitch.PPA_12214_SEGMENTATION_WITHOUT_CTA]: false,
  [FeatureSwitch.PPA_12241_AI_DATA_EXTRACTION_BANNER]: false,
}

export const ALL_FEATURES_ENABLED: FeatureSwitchMap = {
  [FeatureSwitch.FEATURE_FOR_UNIT_TESTS]: true,
  [FeatureSwitch.PPA_11933_USE_NEW_SUPPLY_DEMAND]: true,
  [FeatureSwitch.PPA_12148_HEYIMMO]: true,
  [FeatureSwitch.PPA_12214_SEGMENTATION_WITHOUT_CTA]: true,
  [FeatureSwitch.PPA_12241_AI_DATA_EXTRACTION_BANNER]: true,
}

export type FeatureSwitchMap = Partial<Record<FeatureSwitch, boolean>>
